import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import Datetime from "react-datetime";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";

import Select from "react-select";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import {
  getSingleNotification,
  updateNotification,
  //searchMedicationForSubProduct
  searchMedicationForRayaProducts
} from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import InputColor from "react-input-color";

class EditNotification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "1",
      title: "",
      titleError: null,
      content: "",
      contentError: null,
      link: "",
      linkError: null,
      itemCode: "",
      itemCodeError: null,
      discount: "",
      discountError: null,
      medication: "",
      medicationError: null,
      external_url: "",
      external_error: "",
      isSubimitted: false,
      _notificationSystem: null,
      cardHidden: true,
      is_featured: "2",
      city_info: [],

      errormessages: [],
      medicationItems: [],
      // medicationList: [],
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.isFalshMedicine = this.isFalshMedicine.bind(this);
    this.coupon_code_error = React.createRef();
  }

  isFalshMedicine = (e) => {
    var checked = e.target.checked;
    if (checked) {
      this.setState({ codeDisabled: "disabled" });
    } else {
      this.setState({ codeDisabled: "" });
    }
    this.setState({ is_flash_coupon: checked });
  };
  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Notification Template</b> - Updated Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
    setTimeout(() => {
      this.props.history.push("/admin/notifications");
    }, 3000);
  }
  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  async componentDidMount() {
    this.getMedicationItems();

    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    var oldid = JSON.parse(localStorage.getItem("notificationID"));

    getSingleNotification(oldid, obj).then((res) => {
      const data = res.data;

      this.setState({
        title: data.title,
        content: data.content,
        link: data.link,
        medication: data.item_code,
        discount: data.discount,
        external_url: data.url
      });
    });

    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
  
  }

  onChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    if (this.state.isSubimitted) {
      this.validate(value, name);
    }

    this.setState({
      [name]: value,
    });
  };

  validate = (value, name) => {
    if (name == "external_url") {
      var url_re =
        /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
      if (this.state.link == null || this.state.link == "") {
        if (value == "" || value == null) {
          this.setState({
            external_error: (
              <small className="text-danger">Please enter external link</small>
            ),
          });
        } else if (url_re.test(value) == false) {
          this.setState({
            external_error: (
              <small className="text-danger">
                Please add valid external link
              </small>
            ),
          });
        } else {
          this.setState({
            external_error: null,
          });
        }
      } else {
        this.setState({
          external_error: null,
        });
      }
    }

    if (name == "link") {
      if (value != "") {
        this.setState({
          external_error: null,
        });
      }
    }
  };

  inputOnChange = (event, i) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      name: event.target.value.trim(),
      typing: false,
      typingTimeout: setTimeout(function () {
        self.sendToParent(self.state.name.trim());
      }, 500),
    });
  };

  getMedicationItems = async () => {
    var token = JSON.parse(localStorage.getItem("user"));

    const obj = token.token;
    await searchMedicationForRayaProducts(this.state.name, obj).then((res) => {
      var medicationItems = [];

      //alert("in else")
      this.setState({ medication_detail: [] });

      res.data.data.map((x, i) => {
        medicationItems.push({
          value: x.item_code,
          label: x.title + " (" + x.item_code + ")",
        });
      });

      this.setState({
        medicationItems: medicationItems,
      });
    });
  }

  sendToParent = async (name) => {
    //this.props.searching(this.state.name);c

    if (this.state.name.length !== 0) {
      let compelte = 1;
      let pg_no = 1;
      var token = JSON.parse(localStorage.getItem("user"));

      const obj = token.token;

      await searchMedicationForRayaProducts(this.state.name, obj).then((res) => {
        var mdata = res.data.data;

        var medicationItems = [];

        //alert("in else")
        this.setState({ medication_detail: [] });

        res.data.data.map((x, i) => {
          medicationItems.push({
            value: x.item_code,
            label: x.title + " (" + x.item_code + ")",
          });
        });

        this.setState({
          medicationItems: medicationItems,
        });
      });
    } else {
      this.setState({ medication_detail: [], medicationItems: [] });
    }
  };
  
  handleSelectChange = (value) => {
    this.setState({
      medication: value.value,
    })
  };

  onSubmit = () => {
    //console.log('onsubmit')
    this.setState({ errormessages: [], isSubimitted: true });
    let error = false;
    if (this.state.title.length == 0) {
      error = true;
      this.setState({
        titleError: <small className="text-danger">Title is required.</small>,
      });
    } else {
      this.setState({ titleError: null });
    }

  //  if (this.state.link == "Raya Screen") {
  //    if (this.state.medication.length == 0) {
  //      error = false;
  //      this.setState({
  //        itemCodeError: (
  //          <small className="text-danger">Item Code is required.</small>
  //        ),
  //      });
  //    } else {
  //      this.setState({ itemCodeError: null });
  //    }

  //    if (this.state.discount.length == 0) {
  //      error = false;
  //      this.setState({
  //        discountError: (
  //          <small className="text-danger">Discount is required.</small>
  //        ),
  //      });
  //    } else {
  //      this.setState({ discountError: null });
  //    }
  //  }

  var url_re =
      /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
    if (this.state.link == null || this.state.link == "") {
      if (this.state.external_url == "" || this.state.external_url == null) {
        error = true;
        this.setState({
          external_error: (
            <small className="text-danger">Please enter external link</small>
          ),
        });
      } else if (url_re.test(this.state.external_url) == false) {
        error = true;
        this.setState({
          external_error: (
            <small className="text-danger">
              Please add valid external link
            </small>
          ),
        });
      } else {
        this.setState({
          external_error: null,
        });
      }
    } else {
      this.setState({
        external_error: null,
      });
    }
    

    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;

      var id = JSON.parse(localStorage.getItem("notificationID"));

      updateNotification(
        id,
        this.state.title,
        this.state.content,
        this.state.link,
        this.state.medication,
        this.state.discount,
        this.state.external_url,
        obj
      )
        .then((res) => {
          if (res.data.success === false) {
            let message = res.data.data;
          } else if (res.data.success === true) {
            this.handleSuccess("bl");
          }
          // this.props.history.push('/admin/medication');
        })
        .catch((error) => {
          this.handleNetworkError("bl");
          console.log(error, "== error");
        });
    }
  };
  handleDateChange = (date) => {
    this.setState({
      startdate: date,
    });
  };
  handleEndDateChange = (date) => {
    this.setState({
      enddate: date,
    });
  };
  setColor = (colors) => {
    this.setState({
      background_color: colors,
    });
  };
  render() {
    const errormessages = this.state.errormessages;

   const Test = this.state.medicationItems.find((item)=>item.value === this.state.medication)
     
    return (
      <div className="main-content">
        <input
          style={{ width: "0px", height: "0px", border: "none" }}
          type="text"
          ref={this.coupon_code_error}
        />
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={6}>
              <Card
                content={
                  <form>
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}

                    <FormGroup>
                      <ControlLabel> Title</ControlLabel>
                      <FormControl
                        name="title"
                        value={this.state.title}
                        onChange={(event) => {
                          this.setState({ title: event.target.value });
                          event.target.value === ""
                            ? this.setState({
                                titleError: (
                                  <small className="text-danger">
                                    Coupon Title is required.
                                  </small>
                                ),
                              })
                            : this.setState({ titleError: null });
                        }}
                        placeholder="Enter Title"
                        type="text"
                      />
                      {this.state.titleError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel> content</ControlLabel>
                      <FormControl
                        name="content"
                        value={this.state.content}
                        onChange={(event) => {
                          this.setState({ content: event.target.value });
                        }}
                        placeholder="Enter Content"
                        type="textarea"
                      />
                      {this.state.contentError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Screen Link</ControlLabel>
                      <select
                        name="link"
                        value={this.state.link}
                        onChange={this.onChange}
                        className="form-control"
                      >
                        <option value="0">Choose Screen Link</option>
                        <option value="Medicine Order Screen">
                          Medicine Order Screen
                        </option>
                        <option value="Lab order Screen">
                          Lab order Screen
                        </option>
                        <option value="Raya Screen">Raya Screen</option>
                        <option value="Wallet Screen">Wallet Screen</option>
                        <option value="Refer & Earn">Refer & Earn</option>
                        <option value="My Order - Raya">My Order - Raya</option>
                        <option value="Leaderboard">Leaderboard</option>
                        <option value="Move & Earn - Homepage">
                          Move & Earn - Homepage
                        </option>
                        <option value="Steps Screen">Steps Screen</option>
                        <option value="Calories Screen">Calories Screen</option>
                        <option value="Points Screen">Points Screen</option>
                        <option value="Leaderboard Permission Screen">
                          Leaderboard Permission Screen
                        </option>
                        <option value="First Advice Screen">
                          First Advice Screen
                        </option>
                        <option value= "Consultation Detail Screen">Consultation Detail Screen</option>
                      </select>
                      {this.state.linkError} 
                    </FormGroup>

                    {this.state.link === 'Raya Screen' &&
                    <>
                    <FormGroup>
                        <ControlLabel>Item Code</ControlLabel>
                        <div
                            onKeyUp={(e) => this.inputOnChange(e)}
                            className="Appy"
                        >
                          {this.state.medication !== "" && this.state.medicationItems.length > 0 &&
                             <Select
                              className="react-select primary"
                              classNamePrefix="react-select"
                              name="description"
                              value={Test}
                              onChange={(value) =>
                                this.handleSelectChange(value)
                              }
                              options={this.state.medicationItems}
                              placeholder="Enter Item Name or Code"
                              noOptionsMessage={() => "Type Item Name or Code"}
                            />
                        }
                          </div>
                          {this.state.medicationError}
                    </FormGroup>
                      <FormGroup>
                          <ControlLabel>Discount</ControlLabel>
                          <FormControl
                            name="discount"
                            value={this.state.discount}
                            onChange={(event) => {
                              this.setState({ discount: event.target.value });
                              event.target.value === ""
                                ? this.setState({
                                  discountError: (
                                    <small className="text-danger">
                                      Discount is required.
                                    </small>
                                  )
                                })
                                : this.setState({ discountError: null });
                            }}
                            placeholder="Enter Discount"
                            type="text" />
                        </FormGroup>
                        </>
                }
                 <FormGroup>
                      <ControlLabel>External Link</ControlLabel>
                      <FormControl
                        name="external_url"
                        value={this.state.external_url}
                        onChange={this.onChange}
                        placeholder="Enter External Link"
                        type="text"
                      />
                      {this.state.external_error}
                    </FormGroup>
                    <Button
                      onClick={this.onSubmit.bind(this)}
                      class="btn-color" //bsStyle="info"
                      fill
                    >
                      Submit
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default EditNotification;
